exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-bullet-___styles__container___HL9un {\n  height: 100%;\n  display: flex;\n  padding-top: 18px;\n}\n\n.src-components-dashboard-widgets-bullet-___styles__block___bqmd6 {\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  transition: height 1s;\n}\n\n.src-components-dashboard-widgets-bullet-___styles__block___bqmd6 > div {\n  text-align: center;\n  max-width: 90%;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-dashboard-widgets-bullet-___styles__container___HL9un",
	"block": "src-components-dashboard-widgets-bullet-___styles__block___bqmd6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/bullet/styles.scss
// module id = 2226
// module chunks = 0